/**
 * 响应码枚举
 */

export const ResultEnum = {
    SUCCESS: "200",
    ERROR: "B0001",
    TOKEN_INVALID:  "user.token.invalid",//令牌无效或过期
    PASSWORD_ERROR:  "user.password-error",//令牌无效或过期
}
